interface FilterPanelProps {
  regions: string[];
  years: string[];
  genres: string[];
  region: string;
  year: string;
  genre: string;
  onRegion: (value: string) => void;
  onYear: (value: string) => void;
  onGenre: (value: string) => void;
  onClear: () => void;
}

interface GroupProps {
  label: string;
  icon: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

function FilterGroup({ label, icon, options, value, onChange }: GroupProps) {
  return (
    <div className="border-b border-background-200 pb-5 last:border-b-0 last:pb-0">
      <h4 className="mb-3 flex items-center gap-2 text-sm font-semibold text-foreground-900">
        <i className={`${icon} text-primary-600`} />
        {label}
      </h4>
      <div className="flex flex-wrap gap-2">
        {["全部", ...options].map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onChange(option)}
            className={`rounded-md px-2.5 py-1.5 text-xs transition-colors cursor-pointer whitespace-nowrap ${
              value === option
                ? "bg-primary-600 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  regions,
  years,
  genres,
  region,
  year,
  genre,
  onRegion,
  onYear,
  onGenre,
  onClear,
}: FilterPanelProps) {
  const hasFilter = region !== "全部" || year !== "全部" || genre !== "全部";

  return (
    <div className="flex flex-col gap-5 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
          <i className="ri-equalizer-line text-primary-600" />
          筛选
        </h3>
        {hasFilter && (
          <button
            type="button"
            onClick={onClear}
            className="flex items-center gap-1 rounded-md px-2 py-1 text-xs text-accent-600 transition-colors hover:bg-accent-50 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line" />
            清空筛选
          </button>
        )}
      </div>
      <FilterGroup
        label="地区"
        icon="ri-earth-line"
        options={regions}
        value={region}
        onChange={onRegion}
      />
      <FilterGroup
        label="年份"
        icon="ri-calendar-line"
        options={years}
        value={year}
        onChange={onYear}
      />
      <FilterGroup
        label="类型"
        icon="ri-price-tag-3-line"
        options={genres}
        value={genre}
        onChange={onGenre}
      />
    </div>
  );
}